import { useSelector } from "react-redux";
import {
  selectOverlayScreen,
  setOverlayScreenAction,
} from "@store/app/appReducer";
import { AdaptiveModal } from "./AdaptiveModal";
import {
  PlanDatePicker,
  PlanDatePickerFooter,
  PlanDatePickerHeader,
} from "./screens/planDatePicker/PlanDatePicker";
import { useAppDispatch } from "@store/store";
import { useCallback, useRef } from "react";
import "./OverlayRouter.css";
import {
  PlanAddToDatePicker,
  PlanAddToDatePickerHeader,
} from "./screens/planAddToDatePicker/PlanAddToDatePicker";
import {
  StartingPoint,
  StartingPointHeader,
} from "./screens/StartingPoint/StartingPoint";

type OverlayRef = {
  save?: () => Promise<void>;
};

const OverlayRouter = () => {
  const overlayScreen = useSelector(selectOverlayScreen);
  const dispatch = useAppDispatch();
  const overlayRef = useRef<OverlayRef | null>(null);

  const handleClose = useCallback(() => {
    dispatch(setOverlayScreenAction());
  }, [dispatch]);

  if (!overlayScreen) {
    return null;
  }

  return (
    <AdaptiveModal isOpen={true} onClose={handleClose} width={440}>
      <div className="overlay-router-component">
        <div className="header">
          {overlayScreen.name === "PlanDatePicker" && <PlanDatePickerHeader />}
          {overlayScreen.name === "PlanAddToDatePicker" && (
            <PlanAddToDatePickerHeader />
          )}
          {overlayScreen.name === "StartingPoint" && <StartingPointHeader />}
        </div>
        <div className="content">
          {overlayScreen.name === "PlanDatePicker" && (
            <PlanDatePicker ref={overlayRef} />
          )}
          {overlayScreen.name === "PlanAddToDatePicker" && (
            <PlanAddToDatePicker ref={overlayRef} />
          )}
          {overlayScreen.name === "StartingPoint" && (
            <StartingPoint ref={overlayRef} />
          )}
        </div>
        <div className="footer">
          {overlayScreen.name === "PlanDatePicker" && (
            <PlanDatePickerFooter overlayRef={overlayRef} />
          )}
        </div>
      </div>
    </AdaptiveModal>
  );
};

export { OverlayRouter };
